export { default, isLowMoca } from './MocaFlag';
